import { render, staticRenderFns } from "./List1.vue?vue&type=template&id=53675b96&scoped=true"
import script from "./List1.vue?vue&type=script&lang=js"
export * from "./List1.vue?vue&type=script&lang=js"
import style0 from "./List1.vue?vue&type=style&index=0&id=53675b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53675b96",
  null
  
)

export default component.exports